export default __webpack_public_path__ + "static/media/background.b2457cf6.png";